import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/energy-usage/EnergyUsageRecent/.eu';
import Kr from '@di-shared/features/history/energy-usage/EnergyUsageRecent/.kr';

export interface EnergyUsageRecentProps {
  vin: string;
}

export default function EnergyUsageRecent({vin}: EnergyUsageRecentProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
